import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Province }         from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "provinceCode",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "PROVINCE_LOADING" });
    },

    /**
     * Fetches the Province List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Province.getAll(params);
        data.sort  = params;
        dispatch({ type : "PROVINCE_LIST", data });
    },

    /**
     * Fetches a single Province
     * @param {Function} dispatch
     * @param {Number}   provinceID
     * @returns {Promise}
     */
    async fetchElem(dispatch, provinceID) {
        const data = await Province.getOne({ provinceID });
        dispatch({ type : "PROVINCE_ELEM", data });
    },

    /**
     * Edits/Creates a Province
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Province.edit(data);
    },

    /**
     * Deletes a Province
     * @param {Function} dispatch
     * @param {Number}   provinceID
     * @returns {Promise}
     */
    deleteElem(dispatch, provinceID) {
        return Province.delete({ provinceID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "PROVINCE_LIST", "PROVINCE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "PROVINCE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "PROVINCE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "PROVINCE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
